import { render, staticRenderFns } from "./PrivateColumnsConstructor.vue?vue&type=template&id=63f763b1"
import script from "./PrivateColumnsConstructor.vue?vue&type=script&lang=js"
export * from "./PrivateColumnsConstructor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63f763b1')) {
      api.createRecord('63f763b1', component.options)
    } else {
      api.reload('63f763b1', component.options)
    }
    module.hot.accept("./PrivateColumnsConstructor.vue?vue&type=template&id=63f763b1", function () {
      api.rerender('63f763b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/private-columns-constructor/PrivateColumnsConstructor.vue"
export default component.exports